import React, { useCallback, useEffect } from 'react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);
  if (!isOpen) return null;
  const titleId = `modal-title-${title.replace(/\s+/g, '-').toLowerCase()}`;
  return <div role="dialog" aria-modal="true" aria-labelledby={titleId} className="fixed inset-0 z-[10000] bg-black/70 flex items-center justify-center p-5" onClick={onClose} data-id="element-236">
      <div className="bg-[#FAF7F2] rounded-2xl p-10 max-w-[700px] w-full max-h-[85vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-237">
        <button onClick={onClose} aria-label={`Close ${title}`} className="absolute top-4 right-5 text-2xl text-[#6B4C3B] bg-transparent border-none cursor-pointer hover:text-[#3D2B1F] min-w-[44px] min-h-[44px] flex items-center justify-center" data-id="element-238">
          ×
        </button>

        <h2 id={titleId} className="text-2xl text-[#3D2B1F] mb-5" data-id="element-239">
          {title}
        </h2>

        <div className="text-sm text-[#6B4C3B] font-sans leading-relaxed" data-id="element-240">
          {children}
        </div>
      </div>
    </div>;
}